import React, { useEffect, useState } from 'react';
import { useInView } from 'react-intersection-observer';

export default function CountUpNumber({ end, suffix = '', duration = 2000 }) {
  const [count, setCount] = useState(0);
  const { ref, inView } = useInView({
    threshold: 0.3,
    triggerOnce: true,
  });

  useEffect(() => {
    if (!inView) return;

    let startTime;
    const startValue = 0;
    const endValue = typeof end === 'string' ? parseInt(end) : end;

    const animate = (currentTime) => {
      if (!startTime) startTime = currentTime;
      const progress = Math.min((currentTime - startTime) / duration, 1);

      setCount(Math.floor(progress * (endValue - startValue) + startValue));

      if (progress < 1) {
        requestAnimationFrame(animate);
      }
    };

    requestAnimationFrame(animate);
  }, [inView, end, duration]);

  return (
    <span
      ref={ref}
      className="leading-none bg-gradient-to-br from-[#CBB26A] to-[#A8914D] text-transparent bg-clip-text inline-block"
    >
      {count}
      {suffix}
    </span>
  );
}
